<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a placement type drop down
    *
    * @since 20210810
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2021 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <label v-if="!hide_label">{{label}}</label>
        <select class="form-control form-control" :name="name" :value="type_data" :key="types_actual.length + '_' + type_data" v-on:input="update_type($event)" >
            <option v-if="default_select.length == 0" :value="default_select_value">Please select a Placement Type</option>
            <option v-else :value="default_select_value">{{default_select}}</option>
            <option v-for="type in types_actual" :key="type.id" :value="type.id">{{type.name}}</option>
        </select>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default {
        props: {
            //the name of the input
            name: {
                type: String,
                default: 'type_id'
            },
            //the types
            types: {
                type: Array,
            },
            //the width
            width: {
                default: ''
            },
            //the defalt value
            value: {
                default: 0
            },
            //the defalt value
            default_select: {
                default: ''
            },
            //the defalt value
            default_select_value: {
                default: 0
            },
            //whether or not to hide the label
            hide_label: {
                default: false
            },
            label: {
                default: 'Placement Type'
            }
        },
        created(){
            this.type_data = this.value;
            if(this.type_data == ''){
                this.type_data = 0;
            }
        },
        data() {
            return {
                type_data: 0,
                types_all: this.types,
            };
        },
        asyncComputed: {
            /**
             * returns current list of jobs
             * 
             * @return Array the list
             */
            types_actual: {
                get() {
                    return loadcomponents.doThread(function({data}) {
                        if(data.academic_year == 0){
                            return self.postMessage(data.types);
                        } else {
                            var arr = [];
                            try
                            {
                                for(var i=0; i<data.types.length; i++){
                                    if((!data.types[i].hidden_years.includes(data.academic_year)) || data.types[i].id == data.type_data){
                                        arr.push(data.types[i]);
                                    }
                                }
                            } catch(error) {
                                console.log('An error updating the types actual in the type drop');
                                if(error.response !== undefined){
                                    console.log('File: ' + error.response.data.file);
                                    console.log('Line: ' + error.response.data.line);
                                    console.log('Message: ' + error.response.data.message);
                                    console.log('Exception: ' + error.response.data.exception);
                                    console.log(error.response.data.trace);
                                } else {
                                    console.log(error);
                                }
                            }
                            return self.postMessage(arr);
                        }
                    }, {types: this.types_all, type_data: this.type_data, academic_year: this.academic_year});
                },
                default: []
            }
        },
        computed: {
            academic_year: function(){
                if(this.$searchAcademicYearId > 0 || this.$searchDateAcademicYearId < 0){
                    return parseInt(this.$searchAcademicYearId + '');
                } else {
                    return parseInt(this.$searchDateAcademicYearId + '');
                }
            }
        },
        methods: {
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_type: function (value) {
                var newValue = 0;
                if(value.target !== undefined){
                    newValue = value.target.value;
                } else {
                    newValue = value;
                }
                this.type_data = newValue;
                this.$emit('input', this.type_data);
            },
        },
    }
</script>
